import React, { ReactNode } from "react";
import LBox, { LBoxProps } from "@components/LBox";
import { AccordionContext } from "./Context";
import LIcon from "@components/LIcon";

export type HeaderProps = LBoxProps & {
  children: ReactNode;
  showExpandIndicator?: boolean;
};

const Header: React.FC<HeaderProps> = ({
  children,
  showExpandIndicator = true,
  ...rest
}) => {
  const context = React.useContext(AccordionContext);
  if (!context) {
    throw new Error("Accordion context not found");
  }

  return (
    <LBox flexDirection="row" justifyContent="space-between" {...rest}>
      {children}
      {showExpandIndicator ? (
        <LIcon name="down_arrow" rotate={context.isOpen ? 180 : 0} size={24} />
      ) : null}
    </LBox>
  );
};

export default Header;
